import styled from 'styled-components'
import { FormattedMessage } from 'react-intl'
import { usePublicCreativeResponsesQuery } from '../graphql/creativeResponses'
import Container, { ShiftAlign } from './layout/Container'
import Stack from './layout/Stack'
import SectionIntro, { SectionIntroHTML } from './SectionIntro'
import Button from './Button'
import Link from './Link'
import ResponseItem from './responses/ResponseItem'

function LetsShare( { title, description } ) {
  const { creativeResponses: responses } = usePublicCreativeResponsesQuery( { limit: 7 } )

  return (
    <Container>
      <ShiftAlign>
        <SectionIntro>
          <h2>{ title }</h2>
          <div>
            <SectionIntroHTML dangerouslySetInnerHTML={ { __html: description } } />
            <Button
              $inline
              $outline
            >
              <Link href="/lets-share">
                <FormattedMessage
                  description="Button: View all creative responses"
                  defaultMessage="View all creative responses"
                  id="pS8k6Q"
                />
              </Link>
            </Button>
          </div>
        </SectionIntro>
      </ShiftAlign>
      <Stack $top={ 2 }>
        <StyledLetsShareGrid>
          <div>
            { responses.map( response => (
              <div key={ response.id }>
                <ResponseItem response={ response } />
              </div>
            ) ) }
          </div>
        </StyledLetsShareGrid>
      </Stack>
    </Container>
  )
}

const StyledLetsShareGrid = styled.div`
  position: relative;
  overflow-x: hidden;

  > div {
    position: relative;
    display: grid;
    grid-template-columns: repeat( 7, 1fr );
    width: calc( ${ ( 7 / 3 ) * 100 }% + ( var( --grid-gutter ) * ${ 7 / 3 } ) );
    left: calc( ( ( -100% / 3 ) - ( var( --grid-gutter ) / 3 ) ) * 2 );
    margin: 0 var( --grid-parent-gutter );

    > * {
      position: relative;
      margin: var( --grid-child-gutter );

      a {
        position: relative;
        display: block;
        width: 100%;
        padding-bottom: 100%;
        background: ${ p => p.theme.colors.highlight };
      }
    }
  }
`

export default LetsShare
